enum EstimateDocumentNumberEnum {
    estimate = 1,
    additional,
    act,
    contract,
}
export default EstimateDocumentNumberEnum;
